<template>
  <Form
    class="commonForm"
    :ref="refName"
    :model="formModel"
    :style="{ 'overflow-y': 'auto', 'overflow-x': 'hidden' }"
    :rules="formRules"
    :label-width="100"
    label-position="right"
  >
    <Row :gutter="16">
      <!-- <Col span="12">
          <FormItem label="PO" prop="po">
              <Select v-model="formModel.po" :disabled="po?true:false" filterable placeholder="请选择PO">
                <Option v-for="(item,index) in maintainList" :key="index" :value="item.project_code">{{item.project_name}}</Option>
            </Select>
          </FormItem>
      </Col> -->
      <!-- <Col span="12">
          <FormItem label="PO" prop="po">
              <Input   v-model="formModel.po"  :disabled="formModel.po ? true : false" placeholder="请输入PO" />
          </FormItem>
      </Col> -->
      <Col span="24">
        <FormItem
          :label="_vm.$t('devicelist.didfile')"
          prop="filename"
          class="layout100"
        >
          <Upload
            :value="formModel.filename"
            type="drag"
            :before-upload="handleUpload"
            action="//jsonplaceholder.typicode.com/posts/"
          >
            <div style="padding: 20px 0">
              <Icon
                type="ios-cloud-upload"
                size="52"
                style="color: #3399ff"
              ></Icon>
              <p>{{ _vm.$t("devicelist.uploadxlsx") }}</p>
            </div>
          </Upload>
          <div>{{ formModel.filename ? formModel.filename.name : "" }}</div>
        </FormItem>
        <a
          style="margin-top: 16px"
          :href="`${country_code}/example/example_dids.xlsx`"
          download="uploads_xls.xlsx"
          >{{ _vm.$t("devicelist.downexample") }}</a
        >
      </Col>
      <Col span="24" style="margin-top: 20px">
        <!-- <FormItem label="经销商"  prop="merchant_code">
              <Input v-model="formModel.merchant_code" placeholder="请输入经销商" />
          </FormItem> -->
        <FormItem :label="_vm.$t('alarmmenu.agent')" prop="merchant_code">
          <Cascader
            :data="merchantData"
            change-on-select
            v-model="formModel.merchant_code"
            transfer
            :placeholder="_vm.$t('alarmmenu.agentplaceholer')"
            filterable
          ></Cascader>
        </FormItem>
      </Col>

      <!-- <Col span="12"> -->
      <!-- <FormItem label="出货区域">
            <Input v-model="formModel.center" readonly placeholder="请输入出货区域" />
          </FormItem> -->
      <!-- <FormItem label="出货区域" prop="area_codes">

                 <Tree v-model="formModel.area_codes" :data="areaData" show-checkbox multiple  @on-check-change="onCheckChange"></Tree>
            </FormItem>
      </Col> -->
      <!-- <Col span="12">
          <FormItem label="报警数量">
              <Input v-model="formModel.alarm_num" placeholder="请输入报警数量" type="number"/>
          </FormItem>

      </Col> -->
      <!-- <Col span="12">
          <FormItem label="楼层数" prop="floor_num">
              <InputNumber v-model="formModel.floor_num" style="width:100%" controls-outside :min="-10" placeholder="请输入楼层数" />
          </FormItem>
      </Col> -->
      <!-- <Col span="24">
          <FormItem label="平面图" prop="floor_file">
            <Upload
                v-model="formModel.floor_file"
                type="drag"
                :data="{dir:'floor_file'}"
                :default-file-list="uploadList"
                :format="format"
                name="filename"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                :on-success="handleSuccess"
                :action="getAction">
                <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>上传平面图</p>
                </div>
            </Upload>
          </FormItem>
      </Col> -->
    </Row>
  </Form>
</template>

<script>
import config from "@/config";
import { pests } from "@/api/api_url";
import { getToken, formatYMD } from "@/libs/util";
import { renderFormMixins } from "@/mixins/renderFormMixins";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmCityList from "vue-baidu-map/components/controls/CityList.vue";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmLabel from "vue-baidu-map/components/overlays/Label.vue";
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch.vue";
import {
  area_list,
  get_merchant_all,
  allocation_add,
} from "@/api/jingxiaoshang";
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data() {
    return {
      merchantData: [],
      areaData: [],
      country_code: "",
      headers: {
        Authorization: getToken(),
      },

      formModel: {
        dids: null, //did
        merchant_code: null,
        filename: null,
      },
      formRules: {
        // area_codes:[{required: true,type:'array', message: '出货区域不能为空', trigger: 'blur'}
        // ],

        allocation_num: [
          { required: true, message: "分配数量不能为0", trigger: "change" },
        ],
        merchant_code: [
          {
            required: true,
            type: "array",
            message: this._vm.$t("devicelist.dailinotnull"),
            trigger: "change",
          },
        ],
      },
      textData: null,
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    projectCode: {},
    dids: {},
  },

  computed: {},
  methods: {
    handleUpload(file) {
      console.log("filefile", file);

      //debugger
      if (file.name.indexOf(".xls") > -1 || file.name.indexOf(".xlsx") > -1) {
        this.$set(this.formModel, "filename", file);
      } else {
        // this.textData
        this.$Message.error(this._vm.$t("productModule.uploadPlaceHolderType"));
      }
      return false;
    },
    onCheckChange(curr, hVal) {
      console.log(curr, hVal);
      let data = [];
      for (let i in curr) {
        if (curr[i].area_name) {
          data.push(curr[i].area_code);
        }
      }
      this.$set(this.formModel, "area_codes", data);
      console.log(this.formModel.area_codes);
    },
    getAreaData(callback) {
      this.areaData.splice(0);
      area_list({
        page: 1,
        page_size: 1000,
        parent_code: 1,
        all: 2,
        type: 1,
      }).then((res) => {
        if (res.result === 0) {
          //console.log(data)
          let data = res.body.list;
          this.checkTree(data);
          this.areaData = data;
          if (callback) {
            callback();
          }
        }
      });
    },
    checkTree(arr) {
      for (let i in arr) {
        if (arr[i].area_name) {
          arr[i].value = arr[i].area_code;
          arr[i].label = arr[i].area_name;
          arr[i].title = arr[i].area_name;
        } else if (arr[i].shop_name) {
          arr[i].title = arr[i].shop_name;
        }
        if (arr[i].children_shop && arr[i].children_shop.length > 0) {
          arr[i].children.push(...arr[i].children_shop);
        }
        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree(arr[i].children);
        }
      }
    },
    checkTree2(arr) {
      for (let i in arr) {
        arr[i].value = arr[i].merchant_code;
        arr[i].label = arr[i].shop_name;
        if (arr[i].children && arr[i].children.length > 0) {
          this.checkTree2(arr[i].children);
        }
      }
    },
    getMerchantData(callback) {
      this.merchantData.splice(0);
      get_merchant_all({}).then((res) => {
        if (res.result === 0) {
          let data = res.body;
          //console.log("a",data)
          this.checkTree2(data);
          this.merchantData = data;
          if (callback) {
            callback();
          }
        }
      });
    },

    init() {
      // project_list({page:0,page_size:15}).then(res=>{
      //   if(res.result===0){
      //     this.maintainList=res.body.list||[]
      //   }
      // })
    },
  },
  mounted() {
    //debugger
     if (localStorage.getItem("country_code")=='xciot-prod-cnsz') {
      this.country_code = "https://bms-api.xcthings.com";
    } else if (localStorage.getItem("country_code")=='xciot-prod-hk') {
      this.country_code = "https://bms-hk-api.xcthings.com";
    } else if (localStorage.getItem("country_code")=='xciot-prod-us2') {
      this.country_code = "https://bms-us-api.xcthings.com";
    }else if(localStorage.getItem("country_code")=='xciot-prod-eu'){
this.country_code = "https://bms-eu-api.xcthings.com";
    }
    console.log('this.country_code',this.country_code );

    if (this.projectCode) {
      this.$set(this.formModel, "project_code", this.projectCode);
    }
    //alert(123);
    //获取区域列表
    if (this.edit) {
      //  this.getAreaData()
      // this.getAreaData(()=>{
      //         let data=this.getAreaData(this.areaData,this.editData.area_code)
      //         console.log(data)
      //         this.$set(this.formModel,'area_code',data)
      //       })
      this.getMerchantData(() => {
        //  console.log("a", this.merchantData)
        //  console.log("b",this.setData.merchant_code)
      });

      if (this.setData) {
        //  console.log(this.setData)
        this.$set(this.formModel, "dids", [this.setData.did]);
      } else {
        this.$set(this.formModel, "dids", this.dids);
      }
    }
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.commonForm /deep/ .ivu-form-item-label {
  text-align: left !important;
}
.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}

.demo-upload-list img {
  width: 100%;
  height: 100%;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.titleCol {
  text-align: center;
}

.uploadTip {
  font-size: 12px;
  margin-top: -10px;
  margin-bottom: 10px;
}
.contentImg {
  width: 500px;
}
.contentIcon {
  cursor: pointer;
}
.layout50,
.layout100 {
  margin-bottom: 15px;
}

.layout50 {
  width: calc(50% - 12px);
  padding-left: 8px;
  padding-right: 8px;
}
.classLayout {
  display: flex;
  flex-wrap: wrap;
  margin-left: -8px;
  margin-right: -8px;
}
.addLayout {
  text-align: left;
  margin-left: 8px;
}
.uploadInner {
  position: relative;
}
.uploadDelIcon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1111;
}
.bm-view {
  width: 100%;
  height: 300px;
}
.mapWrapper {
  position: relative;
}
.mapWrapper .inputContent {
  position: absolute;
  top: 5px;
  left: 0;
  z-index: 55;
  width: 180px;
}
</style>
